import * as yup from "yup";
import {
  VALID_ACTIVITY_TYPE,
  VALID_CCTV,
  VALID_DATE,
  VALID_DESCRIPTION,
  VALID_INCIDENT_NUMBER,
  VALID_INSTALLATION_ID,
  VALID_OFFICER,
  VALID_OUTCOME,
  VALID_POLICE_INVOLVED,
  VALID_SERVICES_ARRIVED_TIME,
  VALID_SERVICES_DID_NOT_ATTEND,
  VALID_TIME_SERVICES_CONTACTED,
  TIME_NOT_IN_FUTURE,
} from "@common/constants/validation";

// Define the validation schema using yup
export const suspiciousActivitySchema = (optionDisplaySessionsInCompliance) => {
  return yup
    .object()
    .shape({
      date: VALID_DATE,
      time: TIME_NOT_IN_FUTURE,
      activityType: VALID_ACTIVITY_TYPE,
      machine: optionDisplaySessionsInCompliance
        ? VALID_INSTALLATION_ID
        : yup.object().notRequired(),
      machineReference: !optionDisplaySessionsInCompliance
        ? yup.string().required("Machine reference is required")
        : yup.string().notRequired(),
      cctvCatched: VALID_CCTV,
      description: VALID_DESCRIPTION,
      sessionGuids: optionDisplaySessionsInCompliance
        ? yup.array().required()
        : yup.array().notRequired(),
      outcome: VALID_OUTCOME,
      policeInvolved: VALID_POLICE_INVOLVED,
      timeServicesContacted: VALID_TIME_SERVICES_CONTACTED,
      servicesDidNotAttend: VALID_SERVICES_DID_NOT_ATTEND,
      timeServicesArrived: VALID_SERVICES_ARRIVED_TIME,
      officer: VALID_OFFICER,
      incidentNumber: VALID_INCIDENT_NUMBER,
      customers: yup.array().nullable(),
      customerIds: yup.array().nullable(),
    })
    .test(
      "one-of-two",
      "Please select at least one customer",
      function (value) {
        const hasCustomers = value.customers && value.customers.length > 0;
        const hasCustomerIds =
          value.customerIds && value.customerIds.length > 0;
        return hasCustomers || hasCustomerIds;
      },
    );
};
